import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { SeasonProvider } from "context/SeasonContext";
import { NotificationProvider } from "components/Convokko/NotificationProvider";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <SeasonProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </SeasonProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
